import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Mail } from "lucide-react";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";
import { useT } from "@/context/I18nContext";

export default function ForgotPassword() {
  const nav = useNavigate();
  const { locale } = useT();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email, locale });
      setSent(true);
    } catch {
      toast.error("Errore");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen text-slate-100">
      <Navbar />
      <main className="mx-auto max-w-md px-4 py-16">
        <button onClick={() => nav("/")} className="mb-6 flex items-center gap-2 text-sm text-slate-400 hover:text-cyan-300">
          <ArrowLeft className="h-4 w-4" /> Torna alla home
        </button>
        <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-8">
          <Mail className="h-8 w-8 text-cyan-300" />
          <h1 className="mt-3 text-2xl font-bold">Password dimenticata?</h1>
          <p className="mt-1 text-sm text-slate-400">Ti invieremo un link per reimpostarla.</p>
          {sent ? (
            <div data-testid="forgot-sent-msg" className="mt-6 rounded-lg border border-cyan-500/40 bg-cyan-500/10 p-4 text-sm text-cyan-200">
              Se l'account esiste, riceverai un email con il link entro pochi minuti. Controlla anche la casella spam.
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label className="text-slate-300">Email</Label>
                <Input
                  type="email"
                  required
                  data-testid="forgot-email-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-1 border-slate-800 bg-slate-950 text-slate-100"
                />
              </div>
              <Button
                type="submit"
                disabled={busy}
                data-testid="forgot-submit-btn"
                className="w-full bg-cyan-400 text-slate-950 hover:bg-cyan-300"
              >
                {busy ? "Invio..." : "Invia link di reset"}
              </Button>
            </form>
          )}
        </div>
      </main>
    </div>
  );
}
